// Collection Page JavaScript - Team Line Custom Theme

(function() {
  'use strict';

  // Initialize Collection Page
  const initCollectionPage = () => {
    initFilterSidebar();
    initFilterSections();
    initFilterSearch();
    initSorting();
    initSizeButtons();
    initPriceRange();
  };

  // Filter Sidebar
  const initFilterSidebar = () => {
    const sidebar = document.querySelector('[data-filter-sidebar]');
    const overlay = document.querySelector('[data-filter-overlay]');
    const closeBtn = document.querySelector('[data-filter-close]');
    const filterTriggers = document.querySelectorAll('[data-filter-trigger]');
    const body = document.body;

    if (!sidebar) return;

    const openSidebar = (section = null) => {
      sidebar.classList.add('is-open');
      body.style.overflow = 'hidden';
      
      // If a specific section is requested, open it
      if (section) {
        const filterSection = document.querySelector(`[data-filter-section="${section}"]`);
        if (filterSection && !filterSection.classList.contains('is-open')) {
          toggleFilterSection(filterSection);
        }
      }
    };

    const closeSidebar = () => {
      sidebar.classList.remove('is-open');
      body.style.overflow = '';
    };

    // Open sidebar when clicking filter buttons
    filterTriggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const section = trigger.getAttribute('data-filter-trigger');
        openSidebar(section === 'all' ? null : section);
      });
    });

    // Close sidebar
    if (closeBtn) {
      closeBtn.addEventListener('click', closeSidebar);
    }

    // Get panel reference
    const panel = sidebar.querySelector('.collection-filter-sidebar__panel');
    
    // Close sidebar when clicking overlay - this is the main way to close
    if (overlay) {
      overlay.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        closeSidebar();
      });
    }

    // Close sidebar when clicking anywhere on sidebar container (but not the panel)
    sidebar.addEventListener('click', (e) => {
      // Close if clicking on sidebar container itself or overlay
      if (e.target === sidebar || e.target === overlay || e.target.classList.contains('collection-filter-sidebar__overlay')) {
        closeSidebar();
      }
    });

    // Prevent panel clicks from bubbling up and closing sidebar
    if (panel) {
      panel.addEventListener('click', (e) => {
        e.stopPropagation();
      });
    }

    // Close on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && sidebar.classList.contains('is-open')) {
        closeSidebar();
      }
    });
  };

  // Filter Sections (Collapsible)
  const initFilterSections = () => {
    const sectionToggles = document.querySelectorAll('[data-filter-section-toggle]');
    
    sectionToggles.forEach(toggle => {
      toggle.addEventListener('click', () => {
        const section = toggle.closest('[data-filter-section]');
        if (section) {
          toggleFilterSection(section);
        }
      });
    });
  };

  const toggleFilterSection = (section) => {
    section.classList.toggle('is-open');
  };

  // Filter Search (Brand Search)
  const initFilterSearch = () => {
    const searchInput = document.querySelector('[data-filter-search]');
    if (!searchInput) return;

    searchInput.addEventListener('input', (e) => {
      const searchTerm = e.target.value.toLowerCase().trim();
      const brandCheckboxes = document.querySelectorAll('[data-filter-brand]');

      brandCheckboxes.forEach(checkbox => {
        const brandLabel = checkbox.querySelector('.filter-checkbox__label');
        const brandText = brandLabel ? brandLabel.textContent.toLowerCase() : '';
        
        if (brandText.includes(searchTerm)) {
          checkbox.classList.remove('hidden');
        } else {
          checkbox.classList.add('hidden');
        }
      });
    });
  };

  // Size Filter Buttons
  const initSizeButtons = () => {
    const sizeButtons = document.querySelectorAll('[data-size-button]');
    
    sizeButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        button.classList.toggle('is-active');
      });
    });
  };

  // Price Range Filter
  const initPriceRange = () => {
    const priceMin = document.querySelector('[data-price-min]');
    const priceMax = document.querySelector('[data-price-max]');
    const priceMinInput = document.querySelector('[data-price-min-input]');
    const priceMaxInput = document.querySelector('[data-price-max-input]');

    if (!priceMin || !priceMax) return;

    const syncSliderToInput = (slider, input, isMax = false) => {
      if (!input) return;
      const value = parseInt(slider.value);
      input.value = value;
      
      // Ensure min doesn't exceed max
      if (!isMax && priceMax && parseInt(priceMax.value) < value) {
        priceMax.value = value;
        if (priceMaxInput) priceMaxInput.value = value;
      }
      // Ensure max doesn't go below min
      if (isMax && priceMin && parseInt(priceMin.value) > value) {
        priceMin.value = value;
        if (priceMinInput) priceMinInput.value = value;
      }
    };

    const syncInputToSlider = (input, slider, isMax = false) => {
      if (!input) return;
      let value = parseInt(input.value) || 0;
      const maxLimit = parseInt(slider.max) || 500;
      const minLimit = parseInt(slider.min) || 0;
      
      // Clamp value to limits
      value = Math.max(minLimit, Math.min(maxLimit, value));
      input.value = value;
      slider.value = value;
      
      // Ensure min doesn't exceed max
      if (!isMax && priceMax && parseInt(priceMax.value) < value) {
        priceMax.value = value;
        if (priceMaxInput) priceMaxInput.value = value;
      }
      // Ensure max doesn't go below min
      if (isMax && priceMin && parseInt(priceMin.value) > value) {
        priceMin.value = value;
        if (priceMinInput) priceMinInput.value = value;
      }
    };

    // Sync sliders to inputs
    if (priceMin) {
      priceMin.addEventListener('input', () => syncSliderToInput(priceMin, priceMinInput, false));
    }
    if (priceMax) {
      priceMax.addEventListener('input', () => syncSliderToInput(priceMax, priceMaxInput, true));
    }

    // Sync inputs to sliders
    if (priceMinInput) {
      priceMinInput.addEventListener('input', () => syncInputToSlider(priceMinInput, priceMin, false));
      priceMinInput.addEventListener('blur', () => syncInputToSlider(priceMinInput, priceMin, false));
    }
    if (priceMaxInput) {
      priceMaxInput.addEventListener('input', () => syncInputToSlider(priceMaxInput, priceMax, true));
      priceMaxInput.addEventListener('blur', () => syncInputToSlider(priceMaxInput, priceMax, true));
    }

    // Initialize
    syncSliderToInput(priceMin, priceMinInput, false);
    syncSliderToInput(priceMax, priceMaxInput, true);
  };

  // Apply Filters
  const applyFilters = () => {
    const filterForm = document.querySelector('[data-filter-form]');
    if (!filterForm) return;

    const formData = new FormData(filterForm);
    const params = new URLSearchParams();

    // Get current URL params
    const currentParams = new URLSearchParams(window.location.search);
    
    // Preserve search query if on search page
    const searchQuery = currentParams.get('q');
    if (searchQuery) {
      params.set('q', searchQuery);
    }
    
    const currentSort = currentParams.get('sort_by');
    if (currentSort) {
      params.set('sort_by', currentSort);
    }

    // Collect all checkbox values for each filter type
    const vendorFilters = [];
    const productTypeFilters = [];
    const colorFilters = [];
    let priceMin = null;
    let priceMax = null;

    // Process form data
    formData.forEach((value, key) => {
      if (value && value !== '' && key !== 'price_min_input' && key !== 'price_max_input') {
        if (key === 'filter.v.vendor') {
          vendorFilters.push(value);
        } else if (key === 'filter.v.product_type') {
          productTypeFilters.push(value);
        } else if (key === 'filter.v.option.color') {
          colorFilters.push(value);
        } else if (key === 'price_min') {
          priceMin = parseInt(value) || 0;
        } else if (key === 'price_max') {
          priceMax = parseInt(value) || 500;
        }
      }
    });

    // Add vendor filters
    if (vendorFilters.length > 0) {
      vendorFilters.forEach(vendor => {
        params.append('filter.v.vendor', vendor);
      });
    }

    // Add product type filters
    if (productTypeFilters.length > 0) {
      productTypeFilters.forEach(type => {
        params.append('filter.v.product_type', type);
      });
    }

    // Add color filters
    if (colorFilters.length > 0) {
      colorFilters.forEach(color => {
        params.append('filter.v.option.color', color);
      });
    }

    // Handle price range - Shopify uses filter.v.price.gte and filter.v.price.lte
    if (priceMin !== null && priceMin > 0) {
      params.set('filter.v.price.gte', priceMin.toString());
    }
    if (priceMax !== null && priceMax < 500) {
      params.set('filter.v.price.lte', priceMax.toString());
    }

    // Handle size buttons - Shopify uses filter.v.option.size
    const activeSizes = [];
    document.querySelectorAll('[data-size-button].is-active').forEach(btn => {
      const size = btn.getAttribute('data-size');
      if (size && size !== '1SZ') { // Skip placeholder size
        activeSizes.push(size);
      }
    });
    if (activeSizes.length > 0) {
      activeSizes.forEach(size => {
        params.append('filter.v.option.size', size);
      });
    }

    // Update URL and reload
    // Preserve search query in pathname for search pages
    let pathname = window.location.pathname;
    // Note: currentParams and searchQuery already declared above
    if (searchQuery && pathname.includes('/search')) {
      // Search page - ensure q parameter is included
      if (!params.has('q')) {
        params.set('q', searchQuery);
      }
    }
    
    const newUrl = pathname + (params.toString() ? '?' + params.toString() : '');
    window.location.href = newUrl;
  };

  // Initialize filter form submission
  const filterForm = document.querySelector('[data-filter-form]');
  if (filterForm) {
    filterForm.addEventListener('submit', (e) => {
      e.preventDefault();
      applyFilters();
    });

    const applyBtn = document.querySelector('[data-filter-apply]');
    if (applyBtn) {
      applyBtn.addEventListener('click', (e) => {
        e.preventDefault();
        applyFilters();
      });
    }
  }

  // Sorting Functionality
  const initSorting = () => {
    const sortSelect = document.querySelector('[data-sort-select]');
    if (!sortSelect) return;

    // Set current sort value from URL
    const urlParams = new URLSearchParams(window.location.search);
    const currentSort = urlParams.get('sort_by');
    if (currentSort) {
      sortSelect.value = currentSort;
    }

    // Handle sort change
    sortSelect.addEventListener('change', (e) => {
      const sortValue = e.target.value;
      const url = new URL(window.location);
      
      // Preserve search query if on search page
      const currentParams = new URLSearchParams(window.location.search);
      const searchQuery = currentParams.get('q');
      if (searchQuery && !url.searchParams.has('q')) {
        url.searchParams.set('q', searchQuery);
      }
      
      if (sortValue) {
        url.searchParams.set('sort_by', sortValue);
      } else {
        url.searchParams.delete('sort_by');
      }

      window.location.href = url.toString();
    });
  };

  // Load More Products
  const initLoadMore = () => {
    const loadMoreBtn = document.querySelector('[data-load-more-btn]');
    const productGrid = document.querySelector('[data-product-grid]');
    
    if (!loadMoreBtn || !productGrid) return;

    loadMoreBtn.addEventListener('click', async () => {
      const nextUrl = loadMoreBtn.getAttribute('data-next-url');
      const currentPage = parseInt(loadMoreBtn.getAttribute('data-current-page')) || 1;
      const totalPages = parseInt(loadMoreBtn.getAttribute('data-total-pages')) || 1;
      
      if (!nextUrl || currentPage >= totalPages) return;

      // Show loading state
      loadMoreBtn.classList.add('is-loading');
      loadMoreBtn.disabled = true;

      try {
        // Fetch next page
        const response = await fetch(nextUrl);
        const html = await response.text();
        
        // Create temporary container to parse HTML
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        
        // Find the product grid in the fetched HTML
        const fetchedGrid = tempDiv.querySelector('[data-product-grid]');
        const fetchedLoadMore = tempDiv.querySelector('[data-load-more-container]');
        
        if (fetchedGrid) {
          // Append new products to existing grid
          const newProducts = fetchedGrid.querySelectorAll('.collection-grid__item');
          newProducts.forEach(item => {
            productGrid.appendChild(item);
          });
          
          // Update load more button with next page info
          if (fetchedLoadMore) {
            const nextLoadMoreBtn = fetchedLoadMore.querySelector('[data-load-more-btn]');
            if (nextLoadMoreBtn) {
              loadMoreBtn.setAttribute('data-next-url', nextLoadMoreBtn.getAttribute('data-next-url') || '');
              loadMoreBtn.setAttribute('data-current-page', nextLoadMoreBtn.getAttribute('data-current-page') || '1');
              loadMoreBtn.setAttribute('data-total-pages', nextLoadMoreBtn.getAttribute('data-total-pages') || '1');
            } else {
              // No more pages, hide button
              loadMoreBtn.closest('[data-load-more-container]').style.display = 'none';
            }
          } else {
            // No more pages, hide button
            loadMoreBtn.closest('[data-load-more-container]').style.display = 'none';
          }
        }
      } catch (error) {
        console.error('Error loading more products:', error);
        alert('Failed to load more products. Please try again.');
      } finally {
        // Remove loading state
        loadMoreBtn.classList.remove('is-loading');
        loadMoreBtn.disabled = false;
      }
    });
  };

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initCollectionPage();
      initLoadMore();
    });
  } else {
    initCollectionPage();
    initLoadMore();
  }

})();
